import { Summary } from '@atom/types/work';

import classes from './workSummaryTray.module.css';

interface Props {
  summary: Summary[];
}

const WorkSummarySection = ({ summary }: Props) => {
  return (
    <div className={classes.summarySectionContainer}>
      {summary.map((section, index) => (
        <div className={classes.summarySection} key={index}>
          <div className={classes.summarySectionTitle}>{section.title}</div>
          <div className={classes.summarySectionContents}>
            {section.contents}
          </div>
        </div>
      ))}
    </div>
  );
};

export default WorkSummarySection;
